module.exports = __webpack_public_path__ + "static/media/Visualise.dc319879.mp4";